import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MfaIpImportOptionDto } from '../interfaces/mfa-ip-import-option-dto';
import { MfaIpImportResultDto } from '../interfaces/mfa-ip-import-result-dto';
import { envToken } from '../tokens/env-token';

@Injectable({
    providedIn: 'root'
})
export class MfaIpImportService {
    private readonly http = inject(HttpClient);


    private readonly baseUrl: string;

    constructor() {
        const env = inject(envToken);

        this.baseUrl = env.apiUrl + '/api/v1/mfa-ip-import';
    }

    fetchOrganizationsWithMfaWhitelistedIps(enterpriseId: number): Observable<MfaIpImportOptionDto[]> {
        return this.http.get<MfaIpImportOptionDto[]>(`${this.baseUrl}/enterprise/${enterpriseId}`);
    }

    importMfaWhitelistedIps(enterpriseId: number, organizationIds: number[]): Observable<MfaIpImportResultDto> {
        return this.http.post<MfaIpImportResultDto>(`${this.baseUrl}/enterprise/${enterpriseId}`, organizationIds);
    }
}
